import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = {
  key: 0,
  class: "summary"
}

import DeliverableSelector from "@/components/selectors/deliverable.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {ref} from "vue"
  import Button from "@/components/button.vue"
  import DeliverableSummary from "@/components/summaries/deliverable.vue"
  import router from "@/router"
  import {Deliverable} from "@/endpoints/rutsolve/gql/generated/graphql"
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'deliverables',
  setup(__props) {

  const selectedDeliverable = ref<Deliverable>(null)
  
  function deliverableRedirect() {
    router.push({
      name: "edit_deliverable",
      params: {
        deliverableID: selectedDeliverable.value.id
      }
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, { links: [{
        title: 'Create',
        routeName: 'create_deliverable'
      }] }, {
        default: _withCtx(() => [
          _createVNode(Breadcrumb, {
            links: [{
          title: 'RutSolve',
          routeName: 'index'
        }],
            title: "Deliverables"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("h1", null, " Deliverables ", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(DeliverableSelector, {
                value: selectedDeliverable.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedDeliverable).value = $event))
              }, null, 8, ["value"])
            ]),
            (selectedDeliverable.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(), _createBlock(DeliverableSummary, {
                    key: selectedDeliverable.value.id,
                    deliverableID: selectedDeliverable.value.id
                  }, null, 8, ["deliverableID"])),
                  _createVNode(Button, {
                    title: "Edit",
                    image: require('@/images/edit_icon.png'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (deliverableRedirect()))
                  }, null, 8, ["image"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})